import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import AdditionalLocationAddEdit from "./AdditionalLocationAddEdit";
import AdditionalLocationTable from "./AdditionalLocationTable";

function AdditionalLocationContainer() {
  const { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route exact path={`${path}/edit/:id`}>
          <AdditionalLocationAddEdit />
        </Route>
        <Route exact path={`${path}/add`}>
          <AdditionalLocationAddEdit />
        </Route>
        <Route path={`${path}`}>
          <AdditionalLocationTable />
        </Route>
      </Switch>
    </>
  );
}

export default AdditionalLocationContainer;
